<template>
  <div class="hello">
    <div id="content">
      <el-card class="box-card" style="margin-bottom: 2vh">
        <div>
          <i class="el-icon-star-on">请输入您单位的管理员登录账户来查询费用信息</i><i class="el-icon-star-on"></i>
          <el-input v-model="userAccount" placeholder="管理员登录账户" style="margin-top: 1vh"></el-input>
          <el-button type="primary" style="width: 100%;margin-top:1vh" @click="getProjectInfo">查询费用信息</el-button>
        </div>

      </el-card>
      <el-card class="box-card">
        <div>
          <el-descriptions title="缴费信息" border column="2">
            <el-descriptions-item label="登录账户(管理员)" span="50">{{adminName}}</el-descriptions-item>
            <el-descriptions-item label="项目名称（停车场/门禁校区）" span="50">{{unitName}}</el-descriptions-item>
            <el-descriptions-item label="通道数量（个）" span="50">{{channelNum}}</el-descriptions-item>
            <el-descriptions-item label="通道数量单价（CNY）" span="50">{{cellPrice}} CNY</el-descriptions-item>
            <el-descriptions-item label="续费时间/单位：" span="50">
              <el-input v-model="chargeNum" placeholder="续费时间" style="margin-top: 1vh;display: block;width: 10vw;margin-bottom: 2px"/>
              <el-select v-model="chargeCell" placeholder="续费单位" style="display: block;width: 10vw">
                <el-option label="月" value='month'></el-option>
                <el-option label="年" value='year'></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="缴费金额" span="50">{{totalCharge}}</el-descriptions-item>
            <el-descriptions-item label="剩余有效期至：" span="50">{{remainTime}}</el-descriptions-item>
            <el-descriptions-item label="当前时间：" span="50">{{newTime}}</el-descriptions-item>
            <el-descriptions-item label="续费有效期至：" span="50">{{expireTime}}</el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <br>
      <el-card class="box-card" style="margin-bottom: 1vh">
        <div>
          <el-button type="success" style="width: 100%;margin-top:1vh" @click="wechatPay">微信支付</el-button>
        </div>
      </el-card>
    </div>

    <el-dialog
            title="请使用微信扫码支付"
            :visible.sync="centerDialogVisible"
            width="25vw"
            center
            :show-close = false>
        <div style="height: 20vw;width: 20vw;margin: 0 auto">
          <img :src="QRcodeImage" style="width: 100%;height: 100%"/>
        </div>
      <br>
    <el-button @click="closeQrcode">取 消</el-button>
    <el-button type="success" @click="queryPayResult">我已支付，刷新结果</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      orderNo:null,
      QRcodeImage:null,
      centerDialogVisible:false,
      newTime:null,
      tableData: null,
      userAccount:'',
      chargeNum:1,
      chargeCell:'month',
      channelNum:0,
      adminName:"输入登录账户后查询",
      unitName:"输入登录账户后查询",
      endTime:"",
      // cellPrice:130.00
    }
  },
  mounted (){
    this.getNowTime();//进入页面调用该方法获取当前时间
    clearInterval(myTimeDisplay );//销毁之前定时器
    let myTimeDisplay = setInterval(() => {
      this.getNowTime(); //每秒更新一次时间
    }, 1000);
  },
  methods:{
    closeQrcode(){
      this.centerDialogVisible = false;
      window.clearInterval(this.timer);
    },
    getNowTime() {
      this.newTime = new Date().toLocaleString();
    },
    getProjectInfo(){
      var userAccount = this.userAccount;
      if (userAccount === ""){
        this.$message.warning("请先输入管理员登录账户再查询！");
        return;
      }
      // eslint-disable-next-line no-unused-vars
      let query = {
        "userAccount":this.userAccount
      };

      this.axios.post("/api/sct/charge/getLastInfo",query).then(res=>{
        // eslint-disable-next-line no-empty
        if (res.status == 200){
          let responseData = res.data;
          if (responseData.code == 0){
            this.adminName = responseData.data.adminName;
            this.unitId = responseData.data.unitId;
            this.unitName = responseData.data.unitName;
            this.channelNum = responseData.data.channelNum;
            this.endTime = responseData.data.lastTime;
          }else {
            this.$message.warning(res.msg);
          }
        }else {
          this.$message.error("服务器内部错误，请联系售后人员！");
        }
      });
      this.$message.success("查询费用信息："+userAccount)
    },
    wechatPay(){
      this.$message.success("拉起微信支付");
      let payRequest = {
        "unitId:":this.unitId,
        "userAccount":this.userAccount,
        "chargeCell":this.chargeCell,
        "chargeNum":this.chargeNum
      };
      this.axios.post("/api/sct/charge/payQRcode",payRequest).then(res=>{
        if (res.status == 200) {
          let responseData = res.data;
          if (responseData.code == 0){
            this.centerDialogVisible = true;
            this.QRcodeImage = responseData.data.qrcode;
            this.orderNo = responseData.data.orderNo;
          }else {
            this.$message.warning(responseData.msg);
          }
        }
      })

      //启动轮询支付结果
      // 实现轮询
      this.timer = window.setInterval(() => {
        setTimeout(this.queryPayResult(), 0);
        // 每三分钟执行 6000*10 * 3
      }, 3000);
    },

    //查询支付结果
    queryPayResult(){
      let payResultQuery = {
        "orderNo":this.orderNo,
      }
      this.axios.post("/api/sct/charge/queryPayResult",payResultQuery).then(res=>{
        if (res.status == 200) {
          let responseData = res.data;
          if (responseData.code == 0 && responseData.data.payStatus == 1){
            this.centerDialogVisible = false;
            this.$message.success("续费成功！");
            window.clearInterval(this.timer);
            // this.getProjectInfo();
          }else {
            // this.$message.error("检查支付中...");
          }
        }else {
          this.$message.error("查询失败，请重试！");
        }
      });
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    cellPrice () {
      if (this.chargeCell === 'month'){
        return 150.00
      }
      if (this.chargeCell === 'year'){
        return 130.00
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    totalCharge (){
      if (this.chargeCell === 'month'){
        return this.cellPrice * this.channelNum * this.chargeNum;
      }
      return this.cellPrice * this.channelNum * this.chargeNum * 12;
    },
    //付费后有效期至
    // eslint-disable-next-line vue/return-in-computed-property
    expireTime (){
      let date = new Date(this.endTime * 1000);
      var now = new Date();
      if (now > date){
        date = now;
      }
      let addYear = 0;
      let addMonth = 0;
      if (this.chargeCell === 'month'){
        addMonth = this.chargeNum % 12;
        addYear = this.chargeNum / 12;
        date.setFullYear(date.getFullYear() + addYear);
        date.setMonth(date.getMonth() + addMonth);
        if (date.getMonth() + addMonth > 12){
          date.setFullYear(date.getFullYear() + 1);
          date.setMonth(date.getMonth() + addMonth - 12);
        }
      }
      if (this.chargeCell === 'year'){
        addYear = this.chargeNum / 1;
        date.setFullYear(date.getFullYear() + addYear);
      }
      return date.toLocaleString();

    },
    //剩余时间
    // eslint-disable-next-line vue/return-in-computed-property
    remainTime (){
      if (this.endTime === ""){
        return new Date().toLocaleString();
      }
      return new Date(this.endTime * 1000).toLocaleString();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#content{
  width: 80vw;
  padding-left: 10vw;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
